import styled from "styled-components";
import { darken } from "polished";
import ReactInputMask from "react-input-mask";
import "../../../styles/sass/Pages/_newDesign.scss";

export const Main = styled.div`
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
	}
`;

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	background: #23242f;
	overflow-y: auto;

	@media only screen and (max-width: 900px) {
		width: 100%;
		background: #13141b;
		overflow-y: unset;
	}
`;

export const Content = styled.section`
	width: 27rem;
	background: #23242f;
	z-index: 1000;
	padding: 1rem 0;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: "MetropolisRegular";

	form {
		width: 27rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	@media only screen and (max-width: 900px) {
		form {
			width: 23rem;
		}
		background: #13141b;
		position: relative;
		width: 23rem;
		justify-content: flex-start;
		padding: 0;
	}

	@media only screen and (max-width: 380px) {
		top: 0.5rem;
		padding: 0;

		form {
			width: 20rem;
		}
	}
`;

export const Title = styled.div`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const FormGroupInput = styled.div`
	position: relative;

	input {
		font-size: 16px;
		color: #ffffff;
		padding: 16px 50px 16px 16px;
		height: 56px;
		outline: none;
		z-index: 1;
		background-color: transparent;
		border-radius: 8px;
		display: block;
		font-family: "MetropolisRegular";
	}

	label {
		font-family: var(--font-family-metropolis-semi-bold);
		margin-bottom: 4px;
	}

	@media only screen and (max-width: 900px) {
		width: 100%;
	}
`;

export const FormGroup = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		justify-content: normal;
	}
`;

export const ContainerPassword = styled.div`
	display: flex;
	align-items: center;
`;

export const InputText = styled(ReactInputMask).withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	font-family: "MetropolisRegular";
	font-size: 16px;
	// width: ${(props) => (props.width ? `${props.width}rem` : "100%")};
	width: 100%;

	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}

	@media only screen and (max-width: 900px) {
		width: 100%;
	}
`;

export const MessageError = styled.span`
	color: #d30d48;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: 12px;
	display: flex;
	align-content: center;
	flex-direction: row;
	line-height: initial;
	margin-top: 4px;

	button {
		color: #d30d48;
		font-size: 12px;
		font-family: var(--font-family-metropolis-semi-bold);
		outline: none !important;
		text-decoration: underline;
		margin-bottom: 1px;
		border: none;
		background: none;
	}
`;

export const Label = styled.label`
	font-size: 12px;
	color: #ffffff;
`;

export const FormGroupLine = styled.div`
	color: #6f6f70;
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	white-space: nowrap;
`;

export const ContainerRequirements = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-evenly;
`;

export const PasswordEye = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	cursor: pointer;
	color: ${(props) => (props.error ? "#D30D48" : "#CACED4")};
	position: absolute;
	right: 16px;
	z-index: 1;
`;

export const Group = styled.div`
	span {
		margin-left: 5px;
		font-family: "MetropolisRegular";
		font-size: 12px;
		color: #ffff;
		margin-bottom: 4px;
	}
`;

export const SubmitButton = styled.button`
	width: 100%;
	margin-top: 40px;
	background-color: #01e59b;
	border-radius: 8px;
	align-self: center;
	color: #13141b;
	padding: 5px;
	border: 0px;
	font-size: 16px;
	height: 40px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	&:disabled {
		opacity: 0.24;
	}

	@media (max-width: 900px) {
		margin-bottom: 7rem; //feito para causa scrool em telas menores
	}
`;
